import React from 'react';
import { AddressProps, MyAddressContextProps } from './types';

export const MyAddressContext = React.createContext<MyAddressContextProps|null>(null);